import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Skeleton } from '@landr/maestro';
import TextDecorationUnderline from 'components/TextDecorationUnderline/TextDecorationUnderline';

const Description = ({
    content = '',
    isLoading,
}: {
    content?: string;
    isLoading: boolean;
}) => {
    if (isLoading) {
        return (
            <>
                <Skeleton width="98%" height="16px" mt={2} mb={9} />
                <Skeleton width="100%" height="16px" mb={9} />
                <Skeleton width="80%" height="16px" mb={4} />
            </>
        );
    }

    return (
        <TextDecorationUnderline nbOfLines={3}>
            <ReactMarkdown children={content} components={{ p: 'span' }} />
        </TextDecorationUnderline>
    );
};

export default Description;
